import { ProgressBar } from '~/components/ui/ProgressBar';

export function SurveyProgress({ max, current }: { max: number; current: number }) {
  return (
    <div className="flex items-center gap-3">
      <ProgressBar
        value={Math.min((100 / max) * current, 100)}
        color="bg-bolt-ds-brand"
        bgColor="bg-bolt-ds-surfaceTwo"
        className="w-22"
      />
      <div className="text-bolt-ds-textSecondary text-sm">
        {current}/{max}
      </div>
    </div>
  );
}
